import {connect} from 'react-redux';
import CustomiseComparableSales from './CustomiseComparableSales';
import {updatePreferences} from '../actionCreators/preferences';
import {findSection, updateSectionValue} from '../ducks/reportSections';
import actionCreators from '../actionCreators/index';

const mapStateToProps = (state) => {
  const {reportSections, reportType: {value: reportTypeValue}, comparableSales} = state;
  return {
    section: findSection(reportSections, reportTypeValue, 'COMPARABLE_SALES'),
    reportType: reportTypeValue,
    selectedComparableSales: comparableSales.selected.filter(id => !comparableSales.featured.includes(id)),
    featuredProperties: comparableSales.selected.filter(id => comparableSales.featured.includes(id)),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendEvent: (section, title) => {
      dispatch(actionCreators.sendEditTitleAnalyticsEvent(section, title));
    },
    updateSectionValue: (value, dataKeyPath, reportType) => {
      dispatch(updateSectionValue({value, reportType, key: 'COMPARABLE_SALES', dataKeyPath: `sectionData.${dataKeyPath}`}));
    },
    updatePreferences: (preferences, reportType) => {
      dispatch(updatePreferences(preferences, reportType));
    }
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    updateSectionValue: (value, dataKeyPath) => {
      dispatchProps.updateSectionValue(value, dataKeyPath, stateProps.reportType);
      dispatchProps.sendEvent(stateProps.section, value);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseComparableSales);
